module.exports = __webpack_public_path__ + "img/Group 1044two.5cae99b3.png";